"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
__export(require("@formily/validator"));
var LifeCycleTypes;
(function (LifeCycleTypes) {
    LifeCycleTypes["ON_FORM_WILL_INIT"] = "onFormWillInit";
    LifeCycleTypes["ON_FORM_INIT"] = "onFormInit";
    LifeCycleTypes["ON_FORM_CHANGE"] = "onFormChange";
    LifeCycleTypes["ON_FORM_MOUNT"] = "onFormMount";
    LifeCycleTypes["ON_FORM_UNMOUNT"] = "onFormUnmount";
    LifeCycleTypes["ON_FORM_SUBMIT"] = "onFormSubmit";
    LifeCycleTypes["ON_FORM_RESET"] = "onFormReset";
    LifeCycleTypes["ON_FORM_SUBMIT_START"] = "onFormSubmitStart";
    LifeCycleTypes["ON_FORM_SUBMIT_END"] = "onFormSubmitEnd";
    LifeCycleTypes["ON_FORM_SUBMIT_VALIDATE_START"] = "onFormSubmitValidateStart";
    LifeCycleTypes["ON_FORM_SUBMIT_VALIDATE_SUCCESS"] = "onFormSubmitValidateSuccess";
    LifeCycleTypes["ON_FORM_SUBMIT_VALIDATE_FAILED"] = "onFormSubmitValidateFailed";
    LifeCycleTypes["ON_FORM_ON_SUBMIT_SUCCESS"] = "onFormOnSubmitSuccess";
    LifeCycleTypes["ON_FORM_ON_SUBMIT_FAILED"] = "onFormOnSubmitFailed";
    LifeCycleTypes["ON_FORM_VALUES_CHANGE"] = "onFormValuesChange";
    LifeCycleTypes["ON_FORM_INITIAL_VALUES_CHANGE"] = "onFormInitialValuesChange";
    LifeCycleTypes["ON_FORM_VALIDATE_START"] = "onFormValidateStart";
    LifeCycleTypes["ON_FORM_VALIDATE_END"] = "onFormValidateEnd";
    LifeCycleTypes["ON_FORM_INPUT_CHANGE"] = "onFormInputChange";
    LifeCycleTypes["ON_FORM_HOST_RENDER"] = "onFormHostRender";
    LifeCycleTypes["ON_FORM_GRAPH_CHANGE"] = "onFormGraphChange";
    LifeCycleTypes["ON_FIELD_WILL_INIT"] = "onFieldWillInit";
    LifeCycleTypes["ON_FIELD_INIT"] = "onFieldInit";
    LifeCycleTypes["ON_FIELD_CHANGE"] = "onFieldChange";
    LifeCycleTypes["ON_FIELD_INPUT_CHANGE"] = "onFieldInputChange";
    LifeCycleTypes["ON_FIELD_VALUE_CHANGE"] = "onFieldValueChange";
    LifeCycleTypes["ON_FIELD_INITIAL_VALUE_CHANGE"] = "onFieldInitialValueChange";
    LifeCycleTypes["ON_FIELD_VALIDATE_START"] = "onFieldValidateStart";
    LifeCycleTypes["ON_FIELD_VALIDATE_END"] = "onFieldValidateEnd";
    LifeCycleTypes["ON_FIELD_MOUNT"] = "onFieldMount";
    LifeCycleTypes["ON_FIELD_UNMOUNT"] = "onFieldUnmount";
})(LifeCycleTypes = exports.LifeCycleTypes || (exports.LifeCycleTypes = {}));
exports.isField = function (target) {
    return target &&
        target.displayName === 'FieldState' &&
        shared_1.isFn(target.getState) &&
        shared_1.isFn(target.setState);
};
exports.isFieldState = function (target) {
    return target && target.displayName === 'FieldState' && target.name && target.path;
};
exports.isFormState = function (target) {
    return target && target.displayName === 'FormState';
};
exports.isVirtualField = function (target) {
    return target &&
        target.displayName === 'VirtualFieldState' &&
        shared_1.isFn(target.getState) &&
        shared_1.isFn(target.setState);
};
exports.isVirtualFieldState = function (target) {
    return target && target.displayName === 'VirtualFieldState';
};
exports.isStateModel = function (payload) {
    return shared_1.isFn(payload === null || payload === void 0 ? void 0 : payload.getState);
};
